import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Collapse,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import { FormControl, InputLabel } from "@mui/material";
import IconButton from "@material-ui/core/IconButton";
import axios from "axios";
import moment from "moment";
import MainCard from "../../ui-component/cards/MainCard";
import { LoadingButton } from "@material-ui/lab";
import { getDecryptDataFromLocal } from "../../utils/encrypt";
import Ordershippopup from "../Vendor/Ordershippopup";
import AlertModal from "./AlertModal";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const getQueryParams = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

const ALLOWED_USERS = ["WAREHOUSE21", "WAREHOUSE47", "9910249015", "9719836187"];

export default function WarehouseBulkOrderList() {
  const classes = useStyles();
  const paramsData = getQueryParams("orderId");
  const crmPhoneNumner = getDecryptDataFromLocal("phoneNumber");

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [date, setDate] = useState({
    startDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
    endDate: new Date().toISOString().slice(0, 10),
  });
  const [loading, setLoading] = useState(false);
  const [orderdata, setOrderData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [disableBtn, setDisableBtn] = useState(false);
  const [bulkOrderFromRocket, setBulkOrderFromRocket] = useState(false);
  const [parentBulkNumericOrderId, setParentBulkNumericOrderId] = useState(paramsData || "");
  const [openTableIndex, setOpenTable] = useState({ index: null, isOpen: false });
  const [shippingModeModal, setShippingModeModal] = useState(false);
  const [orderIdClick, setOrderIdClick] = useState("");
  const [loadingOfShiprocketOrder, setLoadingOfPlaceOrder] = useState(false);
  const [openShipmentPopup, setShipmentPopup] = useState({
    open: false,
    orderId: null,
    orderName: "",
    type: "",
    isrocketOrPorter: false,
    organizations: null,
  });
  const [shipShopyModal, setShipShopyModal] = useState({
    open: false,
    orderId: null,
    couriers: [],
    loading: false,
    selectedCourierId: "",
    weight: "",
  });
  const [ewayBillModal, setEwayBillModal] = useState({ orderId: "", modal: false });
  const [ewayBillNumber, setEwayBillNumber] = useState("");
  const [isZohoInvoce, setIsZohoInvoice] = useState(null);

  // Access control
  useEffect(() => {
    if (!ALLOWED_USERS.includes(crmPhoneNumner)) {
      window.location.href = "/dashboard/default";
    }
  }, []);

  useEffect(() => {
    if (paramsData) {
      dataLoad(page, rowsPerPage);
    }
  }, [paramsData]);

  const dataLoad = (p = page, row = rowsPerPage) => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/sales/getBulkOrders", {
        status: 1,
        page: p + 1,
        pageLimit: row,
        startDate: date.startDate,
        endDate: date.endDate,
        parentBulkNumericOrderId: +parentBulkNumericOrderId,
        callFromWarehouse: true,
      })
      .then((res) => {
        if (res.data.success) {
          setOrderData(res.data.data[0].data || []);
          setTotalPage(res.data.data[0]?.metadata[0]?.totalDocuments);
        } else {
          alert(res.data?.message || "Something went wrong");
        }
        setLoading(false);
        setDisableBtn(false);
      })
      .catch(() => setLoading(false));
  };

  const bookInventory = async (orderId) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_PATH}/role4/bookInventroyForOrder`, { orderId });
      if (res.data.success) return true;
      alert(res.data.message || "Failed to book inventory");
      return false;
    } catch (err) {
      alert(err?.response?.data?.message || "Error booking inventory. Please try again.");
      return false;
    }
  };

  const updateEwayBillNumber = () => {
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/products/updateEwayBillNumber", {
        orderId: ewayBillModal.orderId,
        ewayBillNumber: ewayBillNumber,
      })
      .then((res) => {
        if (res.data.success) {
          alert("Updated successfully");
          dataLoad(page, rowsPerPage);
          setEwayBillModal({ modal: false, orderId: "" });
        } else {
          alert(res.data?.message || "Something went wrong");
        }
      })
      .catch(() => alert("Something went wrong"));
  };

  const handleShipShopyAction = (order) => {
    if (order?.shipShopyResponse?.orderType === "SPS" && order?.shipShopyResponse?.courierAssigned === false) {
      setShipShopyModal({ ...shipShopyModal, open: true, orderId: order?._id, weight: order?.weight || "", loading: true, couriers: [] });
      axios.post(process.env.REACT_APP_PATH_BULK + "/products/getAvailableCouriers", { orderId: order?._id })
        .then((res) => {
          if (res.data.result === "1" || res.data.success) {
            setShipShopyModal({ open: true, orderId: order?._id, weight: order?.weight || "", couriers: res.data.data, loading: false, selectedCourierId: "" });
          } else {
            alert(res.data.message || "Failed to fetch couriers");
            setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" });
          }
        })
        .catch(() => {
          alert("Something went wrong");
          setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" });
        });
      return;
    }
    setDisableBtn(true);
    let payload = { orderId: order?._id };
    if (order?.shipShopyResponse?.courierAssigned === false) payload.assignCourier = true;
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/products/updateAwbNumberInShipShopyOrders", payload)
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message || "Updated Successfully");
          dataLoad();
          window.location.reload();
        } else {
          alert(res.data.message || "Something went wrong");
          setDisableBtn(false);
        }
      })
      .catch(() => {
        alert("Something went wrong");
        setDisableBtn(false);
      });
  };

  const submitShipShopyCourier = () => {
    if (!shipShopyModal.selectedCourierId) { alert("Please select a courier"); return; }
    setShipShopyModal({ ...shipShopyModal, loading: true });
    axios
      .post(process.env.REACT_APP_PATH_BULK + "/products/updateAwbNumberInShipShopyOrders", {
        orderId: shipShopyModal.orderId,
        courierId: shipShopyModal.selectedCourierId,
        assignCourier: true,
      })
      .then((res) => {
        if (res.data.success) {
          alert(res.data.message || "Updated Successfully");
          setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" });
          dataLoad();
          window.location.reload();
        } else {
          alert(res.data.message || "Something went wrong");
          setShipShopyModal({ ...shipShopyModal, loading: false });
        }
      })
      .catch(() => {
        alert("Something went wrong");
        setShipShopyModal({ ...shipShopyModal, loading: false });
      });
  };

  const handelShippingMode = async (orderId, createInvoice, order) => {
    const booked = await bookInventory(orderId);
    if (!booked) return;
    setDisableBtn(true);
    if (createInvoice) {
      let url = `${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromRocketBox`;
      axios({ method: "POST", url, data: { orderId: order?._id, isrocketOrPorter: true, packagingUnitDetails: [] } })
        .then((res) => {
          if (res.data.success) {
            setDisableBtn(false);
            res?.data?.data?.labelUrl && window.open(res?.data?.data?.labelUrl, "_blank");
            alert("Order shipped successfully");
            dataLoad();
          } else {
            alert(res.data.message || "Something went wrong");
            setDisableBtn(false);
          }
        })
        .catch((err) => {
          alert(err?.response?.data?.message || "Something went wrong");
          setDisableBtn(false);
        });
    } else {
      if (order?.rocketBoxOrderCreatedResp?.order_id) {
        axios.post(process.env.REACT_APP_PATH_BULK + "/products/shipBulkOrderDirectly", { orderId })
          .then((res) => {
            if (res.data.success) {
              alert(res.data?.message || "Success");
              dataLoad();
            } else {
              alert(res.data?.message || "Something went wrong");
              setDisableBtn(false);
            }
          })
          .catch(() => { alert("Server error"); setDisableBtn(false); });
      } else {
        setShippingModeModal(true);
        setOrderIdClick(orderId);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dataLoad(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const rows = parseInt(event.target.value, 10);
    setRowsPerPage(rows);
    dataLoad(0, rows);
    setPage(0);
  };

  // Row for orders WITHOUT child orders
  function CollapesRow({ order, index }) {
    const [showProducts] = useState(order?.products || []);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              size="small"
              onClick={() =>
                setOpenTable({ index, isOpen: !(openTableIndex.isOpen && openTableIndex.index === index) })
              }
            >
              {openTableIndex.index === index && openTableIndex.isOpen
                ? <KeyboardArrowUpIcon />
                : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell>{order.numericOrderId}</TableCell>
          <TableCell>{order?.name}</TableCell>
          <TableCell>{order?.phoneNumber}</TableCell>
          <TableCell>{order?.agent?.name}</TableCell>
          <TableCell>{moment(order.createdAt).format("HH:mm A - DD/MM/YYYY")}</TableCell>
          <TableCell>{order?.seller?.gstNumber || "not found"}</TableCell>
          <TableCell>{order?.seller?.businessName || "not found"}</TableCell>
          <TableCell>{order?.totalPayableAmount}</TableCell>
          <TableCell>{order?.weight || ""}</TableCell>
          <TableCell>{order?.shippingSuggestion || ""}</TableCell>
          <TableCell>
            {(order.shipShopyOrderId || order.shipShopyResponse) && !order.awbNumber && (
              <Grid style={{ marginTop: 10, marginBottom: 10 }}>
                <Button
                  onClick={() => handleShipShopyAction(order)}
                  variant="contained"
                  style={{ width: 130 }}
                  disabled={disableBtn}
                >
                  {order?.shipShopyResponse?.courierAssigned ? "Fetch AWB" : "Assign Courier"}
                </Button>
              </Grid>
            )}
          </TableCell>
        </TableRow>

        {/* Expanded products table */}
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse
              in={openTableIndex.isOpen && index === openTableIndex.index}
              timeout="auto"
              unmountOnExit
            >
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">Products</Typography>
                <Table size="small" aria-label="products">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ minWidth: 250 }}>Name</TableCell>
                      <TableCell>MRP</TableCell>
                      <TableCell>Total Quantity</TableCell>
                      <TableCell>Case Size</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showProducts.map((pro, i) => (
                      <TableRow key={i}>
                        <TableCell>{pro?.name}</TableCell>
                        <TableCell>{pro?.mrp}</TableCell>
                        <TableCell>{pro?.quantity}</TableCell>
                        <TableCell>{pro?.caseSize || 0}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  // Row for orders WITH child orders
  function CollapesRowForChildProduct({ order, index }) {
    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              size="small"
              onClick={() =>
                setOpenTable({ index, isOpen: !(openTableIndex.isOpen && openTableIndex.index === index) })
              }
            >
              {openTableIndex.index === index && openTableIndex.isOpen
                ? <KeyboardArrowUpIcon />
                : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell>{order.numericOrderId}</TableCell>
          <TableCell>{order?.name}</TableCell>
          <TableCell>{order?.phoneNumber}</TableCell>
          <TableCell>{order?.agent?.name}</TableCell>
          <TableCell>{moment(order.createdAt).format("HH:mm A - DD/MM/YYYY")}</TableCell>
          <TableCell>{order?.seller?.gstNumber || "not found"}</TableCell>
          <TableCell>{order?.seller?.businessName || "not found"}</TableCell>
          <TableCell>{order?.totalPayableAmount}</TableCell>
          <TableCell>{order?.weight || ""}</TableCell>
          <TableCell>{order?.shippingSuggestion || ""}</TableCell>
          <TableCell />
        </TableRow>

        {/* Expanded child orders table */}
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse
              in={openTableIndex.isOpen && index === openTableIndex.index}
              timeout="auto"
              unmountOnExit
            >
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="child-orders">
                  <TableHead>
                    <TableRow>
                      <TableCell>Order Id</TableCell>
                      <TableCell>Total Payable</TableCell>
                      <TableCell>Invoice No.</TableCell>
                      <TableCell>Eway Bill Number</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {order.childOrders.map((childOrder, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{childOrder.numericOrderId}</TableCell>
                        <TableCell>{childOrder.totalPayableAmount}</TableCell>
                        <TableCell>{childOrder.zohoInvoice?.zohoInvoiceNumber || ""}</TableCell>
                        <TableCell>{childOrder?.ewayBillNumber || ""}</TableCell>
                        <TableCell
                          style={{ minWidth: 220, flexDirection: "row", display: "flex", alignItems: "center" }}
                        >
                          {childOrder?.status == 1 && order.awbNumber && !childOrder?.awbNumber ? (
                            <>
                              {childOrder.shipShopyOrderId || childOrder.shipShopyResponse ? (
                                <Button
                                  size="small"
                                  disabled={disableBtn}
                                  variant="outlined"
                                  onClick={() => handleShipShopyAction(childOrder)}
                                >
                                  {childOrder?.shipShopyResponse?.courierAssigned ? "Fetch AWB" : "Assign Courier"}
                                </Button>
                              ) : (
                                <>
                                  {childOrder.zohoInvoice?.zohoInvoiceNumber && (
                                    <Button
                                      size="small"
                                      disabled={disableBtn || loading}
                                      variant="outlined"
                                      onClick={() => {
                                        setIsZohoInvoice(childOrder.zohoInvoice?.zohoInvoiceNumber || null);
                                        handelShippingMode(childOrder?._id, false, childOrder);
                                      }}
                                    >
                                      Ship Order
                                    </Button>
                                  )}
                                  {childOrder?.zohoInvoice?.total >= 50000 && !childOrder?.ewayBillNumber && (
                                    <Button
                                      size="small"
                                      disabled={disableBtn || loading}
                                      style={{ marginLeft: 10 }}
                                      variant="outlined"
                                      onClick={() => setEwayBillModal({ orderId: childOrder._id, modal: true })}
                                    >
                                      Update Eway Bill
                                    </Button>
                                  )}
                                </>
                              )}
                            </>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  if (!ALLOWED_USERS.includes(crmPhoneNumner)) return null;

  return (
    <>
      <MainCard content={false} title="Order List">
        <Grid container spacing={2} alignItems="center" style={{ padding: "16px" }}>
          <Grid xs={12} sm={12} md={6} lg={3} item>
            <TextField
              label="Start Date"
              type="date"
              defaultValue={date.startDate}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              style={{ width: "100%" }}
              onChange={(e) => setDate({ ...date, startDate: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <TextField
              label="End Date"
              type="date"
              defaultValue={date.endDate}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              style={{ width: "100%" }}
              onChange={(e) => setDate({ ...date, endDate: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <TextField
              label="Order Id"
              defaultValue={parentBulkNumericOrderId}
              fullWidth
              onChange={(e) => setParentBulkNumericOrderId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <LoadingButton
              variant="contained"
              style={{ width: "100%" }}
              loadingIndicator="loading..."
              onClick={() => dataLoad()}
              loading={loading}
            >
              Submit
            </LoadingButton>
          </Grid>
        </Grid>

        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
            <Grid row container alignItems="center">
              <Grid item xs={12} lg={4} ml={2}>
                <Button onClick={() => dataLoad(page, rowsPerPage)} variant="contained" style={{ marginLeft: 10 }}>
                  Refresh
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>

        <TableContainer style={{ overflowX: "auto", width: "100%" }}>
          <Table aria-label="warehouse bulk order list">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", padding: "16px" }} />
                <TableCell sx={{ fontWeight: "bold", minWidth: 100 }}>Order Id</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>Phone Number</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>Agent Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>Order Date</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 130 }}>GST Number</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>Business Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>Total Payable</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>Weight</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>Shipping Suggestion</TableCell>
                <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} align="center" style={{ padding: 40 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : orderdata.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <Typography color="textSecondary">No orders found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                orderdata.map((order, index) =>
                  order?.childOrders?.length > 0 ? (
                    <CollapesRowForChildProduct key={order._id} order={order} index={index} />
                  ) : (
                    <CollapesRow key={order._id} order={order} index={index} />
                  )
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[25, 100, 200]}
          component="div"
          count={totalpage}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </MainCard>

      {/* Ship popup (RocketBox / Porter) */}
      <Ordershippopup
        openShipmentPopup={openShipmentPopup}
        setShipmentPopup={setShipmentPopup}
        bulkOrder={true}
        bulkOrderFromRocket={bulkOrderFromRocket}
        isrocketOrPorter={openShipmentPopup.isrocketOrPorter}
      />

      {/* Shipping mode selection (RocketBox / Porter prompt) */}
      <AlertModal
        visible={shippingModeModal}
        orderId={orderIdClick}
        onClose={() => { setShippingModeModal(false); setIsZohoInvoice(null); }}
        isZohoInvoce={isZohoInvoce}
        okPress={() => {
          setTimeout(() => {
            setShipmentPopup({
              open: true,
              orderId: orderIdClick,
              orderName: "rocketBox",
              type: "unicommerce",
              isrocketOrPorter: true,
            });
            setBulkOrderFromRocket(true);
          }, 200);
          setShippingModeModal(false);
          setIsZohoInvoice(null);
        }}
      />

      {/* Eway Bill Dialog */}
      <Dialog open={ewayBillModal.modal} fullWidth>
        <DialogContent>
          <DialogTitle>
            <Grid container>
              <Grid item lg={6}>
                <Typography variant="h3">Update Eway Bill Number</Typography>
              </Grid>
              <Grid item lg={6} justifyContent="flex-end" display="flex">
                <Button variant="outlined" onClick={() => setEwayBillModal({ modal: false, orderId: "" })}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <Grid container>
            <Grid item lg={12}><Divider /></Grid>
          </Grid>
          <Grid container>
            <Grid item lg={8} md={8} sm={12}>
              <DialogContentText>
                <TextField
                  type="text"
                  value={ewayBillNumber}
                  onChange={(e) => setEwayBillNumber(e.target.value)}
                  placeholder="Enter Eway Bill Number"
                  fullWidth
                  required
                />
              </DialogContentText>
            </Grid>
            <Grid item lg={4} md={4} sm={12}>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={() => updateEwayBillNumber()}>
                  Update
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* ShipShopy courier selection Dialog */}
      <Dialog open={shipShopyModal.open} fullWidth>
        <DialogTitle>
          Select Courier {shipShopyModal.weight && `(Weight: ${shipShopyModal.weight} KG)`}
        </DialogTitle>
        <DialogContent>
          {shipShopyModal.loading && shipShopyModal.couriers.length === 0 ? (
            <Typography>Loading couriers...</Typography>
          ) : (
            <FormControl fullWidth style={{ marginTop: 15 }}>
              <InputLabel id="courier-select-label">Select Courier</InputLabel>
              <Select
                labelId="courier-select-label"
                value={shipShopyModal.selectedCourierId}
                onChange={(e) => setShipShopyModal({ ...shipShopyModal, selectedCourierId: e.target.value })}
              >
                {shipShopyModal.couriers.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name} - Charges: ₹{c.total_charges}
                    {c.estimated_delivery ? ` - Est. Delivery: ${c.estimated_delivery}` : ""}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setShipShopyModal({ open: false, orderId: null, couriers: [], loading: false, selectedCourierId: "", weight: "" })
            }
          >
            Cancel
          </Button>
          <LoadingButton
            color="primary"
            variant="contained"
            onClick={submitShipShopyCourier}
            loading={shipShopyModal.loading && shipShopyModal.couriers.length > 0}
            disabled={!shipShopyModal.selectedCourierId}
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
